import {createSelector} from '@reduxjs/toolkit'

import {OverseaDeliveryCustom} from '@web/core/constants'

import {RootState} from './interfaces'

/** 개인 통관 고유 부호 정보 selector */
export const personalCustomsClearanceSelector = createSelector(
    (state: RootState) => state.personalCustomsClearance,
    (personalCustomsClearance) => {
        const {scene, isOverseasDelivery, uses, customType} = personalCustomsClearance
        const enabled = isOverseasDelivery && customType !== OverseaDeliveryCustom.BUSINESS_CUSTOM_CODE
        return {
            ...personalCustomsClearance,
            /** Scene */
            scene,
            /** 편집모드 여부 */
            isEdit: scene === 'edit',
            /** 표시모드 여부 */
            isView: scene === 'view',
            /** 해외 배송 여부 */
            isOverseasDelivery,
            /** 개인통관 고유 부호 활성화 여부 */
            enabled,
            /** 개인통관 고유 부호 활성화 및 해외 상품 존재 여부 (C1 에서 체크) */
            needed: enabled && uses === 'Y',
        }
    },
)

/** 개인통관 고유부호 스크린 상태 */
export const personalCustomsClearanceScreenSelector = (state: RootState) => state.personalCustomsClearance?.screenScene

/** 개인통관 고유부호 관세청 조회 정보 */
export const personalCustomsCodeSelector = (state: RootState) =>
    state.personalCustomsClearance?.customsCode ?? {
        view: '',
        hash: '',
    }
